export { default as addIcon } from "./Addicon.svg";
export { default as arrawDown } from "./arrawDown.svg";
export { default as menu } from "./menu.svg";
export { default as dashboard } from "./dashboard.svg";
export { default as dailyReport } from "./dailyReport.svg";
export { default as question } from "./question.svg";
export { ReactComponent as hideIcon } from "./hideIcon.svg";
export { ReactComponent as eyeIcon } from "./eyeIcon.svg";
export { default as setting} from "./settings.svg";
export { default as languageIcon } from "./languageIcon.svg";
export { ReactComponent as SearchIcon } from "./searchIcon.svg";
export { default as emptyStateIcon } from "./emptyStateIcon.svg";
export { default as globeIcon } from "./globeIcon.svg";
export { default as editIcon } from "./edit.svg";
export { default as deleteIcon } from "./delete.svg";
export { default as arrowDownicon } from "./arrowDownicon.svg";
export { default as arrowUpicon } from "./arrowUpicon.svg";
export { default as arrowForward } from "./arrowForward.svg";
export { default as arrowLeft } from "./arrowLeft.svg";
export { default as arrowRight } from "./arrowRight.svg";
export { default as static_content } from "./static_content.svg";
export { default as staticStrings } from "./staticStrings.svg";
export { default as hcps } from "./hcps.svg";
export { default as plusIcon } from "./plusIcon.svg";
export { default as hcp } from "./hcp.svg";
export { default as patient } from "./patient.svg";
export { default as hospital } from "./hospital.svg";
export { default as hospitalicon } from "./hospitalicon.svg";
export { default as onegrid } from "./oneGrid.svg";
export { default as twoGrid } from "./twoGrid.svg";
export { default as ThreeGrid } from "./threeGrid.svg";
export { ReactComponent as CloseIcon } from "./closeIcon.svg";
export { ReactComponent as SpinnerIcon } from "./spinner.svg";